import { Component, Injector, Input } from "@angular/core";
import { AppComponentBase } from "@shared/common/app-component-base";
@Component({
    selector: "qrmena-overlay",
    templateUrl: "./overlay.component.html"
})
export class QrMenaOverlayComponent extends AppComponentBase {
    @Input() isShow: boolean
    constructor(injector: Injector,) {
        super(injector);

    }
}


// WEBPACK FOOTER //
// ./src/QrMena/components/overlay-component/overlay.component.ts